exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".src-components-data-bank-dataset-detail-content-overview-___overview__container___3ruch {\n  flex: 1;\n  display: flex;\n}\n\n.src-components-data-bank-dataset-detail-content-overview-___overview__description___1koZX {\n  font-size: 28px;\n  line-height: 41px;\n  font-weight: 100;\n  text-align: justify;\n}\n\n@media screen and (max-width: 750px) {\n  .src-components-data-bank-dataset-detail-content-overview-___overview__description___1koZX {\n    font-size: 20px;\n  }\n}", ""]);

// exports
exports.locals = {
	"container": "src-components-data-bank-dataset-detail-content-overview-___overview__container___3ruch",
	"description": "src-components-data-bank-dataset-detail-content-overview-___overview__description___1koZX"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./~/resolve-url-loader!./~/sass-loader!./src/components/data-bank/dataset-detail/content/overview/overview.scss
// module id = 1845
// module chunks = 0